<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pt-0">
    <v-col cols="12" md="12" class="pt-0" v-if="showTitle">

      <v-card flat>
        <v-card-title>
          Standorte
          <v-spacer></v-spacer>
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="4" xs="4" class="pl-4">
      <v-select
          v-model="filterTags"
          :items="tags"
          v-if="showTags"
          outlined
          chips
          value="fred"
          deletable-chips
          small-chips
          @change="reFilter"
          label="Gruppe"
          multiple
      ></v-select>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="8" xs="8" md="3" class="">
      <v-text-field
          v-model="search"
          append-icon="search"
          label="Suche"
          clearable
          single-line
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="12" class="pt-0">
      <v-data-table
          :headers="headers"
          :items="filteredItems"
          :search="search"
          show-select
          :custom-filter="doFilter"
          :height="tableHeight"
          v-model="selected"
          hide-default-footer
          hide-details
          :items-per-page="-1"
      >

        <template v-slot:item.name="{ item }">
          <span class="handpointer" @click="editItem(item)">{{ item.name }}</span>
        </template>
        <template v-slot:item.address="{ item }">
          <span>{{ item.street }}<br>{{ item.postcode }} {{ item.city }}</span>
        </template>
        <template v-slot:item.tags="{ item }">
          <v-chip v-for="(c,i) in getTags(item)" :key="i">
            {{ c }}
          </v-chip>
        </template>

        <template v-slot:item.company="{ item }">
            <span :style="getCompanyStyle(item)">
              {{ item.company }}
              <span v-if="!item.company" class="handpointer" @click="openCompanyDialog(item)">zuweisen</span>
            </span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
          >
            edit
          </v-icon>
          <v-icon
              small
              @click="deleteItem(item)"
          >
            delete
          </v-icon>
        </template>
      </v-data-table>
    </v-col>
    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";

var _ = require('lodash')
export default {
  name: 'TableStandorte',
  props: {
    companyId: String,
    showTitle: Boolean,
    filterArray: Array,
    hideAktions: Boolean,
  },
  components: {DialogDeleteItem},
  computed: {
    filteredItems() {
      if (!this.filterArray) {
        return this.deviceList
      }
      const cmp = this
      return _.filter(this.deviceList, function(c) {
        return cmp.filterArray.indexOf(c.guidParent) > - 1
      })
    }
  },
  methods: {

    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Standort',
        id: '' + item.id,
        name: 'Standort ' + item.name,
        item: item
      })
    },
    doDelete: function (item) {
      console.log('item', item.item)
      Vue.prototype.$api.unlinkCompanyToCompany(item.item.guid, this.reload)
    },
    editItem: function (item) {
      if (this.hideAktions) return
      if (this.companyId) {
        this.$router.push('/Netzwerke/' + this.companyId + '/Standort/' + item.guid)
      } else {
        this.$router.push('/Standort/' + item.guid)
      }
    },
    doFilter: function (value, search, item) {
      console.log('doFilter',value, search, item, this.filterArray)
      const isSearch = !search || search.length === 0 || (JSON.stringify(item).indexOf(search) > -1)
      if (!this.filterArray) {
        return isSearch
      } else {
        return isSearch && this.filterArray.indexOf(value.companyId)
      }
    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
          dm = decimals <= 0 ? 0 : decimals || 2,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    reload: function () {
      if (this.companyId != null) {
        if (this.companyId !== '-999') {
          Vue.prototype.$apiCompany.loadCompanies({
            guidParent: this.companyId
          }, this.onGetData)
        }
      } else {
        Vue.prototype.$apiCompany.loadCompanies(null, this.onGetData)
      }

    },
    reloadWithParentId: function (companyId) {
      Vue.prototype.$apiCompany.loadCompanies({
        guidParent: companyId
      }, this.onGetData)
    },
    getTags: function (item) {
      try {
        const t = JSON.parse(item.tags)
        return t
      } catch (e) {
        console.log(e)
      }
    },
    onGetData: function (result) {
      console.log('result', result)
      this.completeData = _.clone(result)
      let map = []
      for (var ii in result) {
        let item = result[ii]
        var t = JSON.parse(item.tags)
        item.tagArray = t
        for (var index in t) {
          let tag = t[index]
          map[tag] = tag
        }
      }
      this.tags = Object.keys(map)
      this.deviceList = result
    },
    reFilter: function () {
      if (this.filterTags.length === 0) {
        this.deviceList = _.clone(this.completeData)
        return
      }
      let list = []
      for (var ii in this.completeData) {
        let item = this.completeData[ii]
        let found = false
        for (var index in item.tagArray) {
          let tag = item.tagArray[index]
          console.log('list', tag, this.filterTags)
          let fIndex = _.findIndex(this.filterTags, function (o) {
            return o === tag
          })
          if (fIndex > -1) {
            found = true
            break
          }
        }
        if (found) {
          list.push(item)
        }
      }
      console.log('list', list)
      this.deviceList = list
    },
    getSelected: function () {
      return this.selected
    },
    setSelected: function (arrayOfSelected) {
      console.log('setSelected', arrayOfSelected)
      this.selected = arrayOfSelected
    },
    resize: function () {
      this.tableHeight = window.innerHeight - 486;
      if (this.showTitle) {
        this.tableHeight = window.innerHeight - 386;
      }
      if (this.tableHeight < 150) {
        this.tableHeight = 150;
      }
    },
  },
  data() {
    return {
      tableHeight: 200,
      showTags: false,
      companyItem: null,
      search: null,
      tags: [],
      completeData: null,
      selected: [],
      filterTags: [],
      headers: [],
      deviceList: []
    }
  },
  watch: {
    selected: function(newVal) {
      this.$emit('input', newVal)
    }
  },
  mounted() {
    var cmp = this
    if (this.showTags) {
      this.headers = [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Adresse', value: 'address'},
        /*{text: 'Strasse', value: 'street'},
        {text: 'PLZ', value: 'postcode'},
        {text: 'Stadt', value: 'city'},*/
        {text: 'Tags', value: 'tags'},
        {text: 'E-Mail', value: 'email'},
        {text: 'Telefon', value: 'phonenumber'},
        {text: 'Aktion', value: 'action'}
        /*{text: 'Erstellt', value: 'created'},
        {text: 'Kommentar', value: 'comment'}
         */
      ]
    } else {
      this.headers = [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Adresse', value: 'address'},
        /*{text: 'Strasse', value: 'street'},
        {text: 'PLZ', value: 'postcode'},
        {text: 'Stadt', value: 'city'},
        {text: 'Tags', value: 'tags'},*/
        {text: 'E-Mail', value: 'email'},
        {text: 'Telefon', value: 'phonenumber'},
        {text: 'Aktion', value: 'action'}
        /*{text: 'Erstellt', value: 'created'},
        {text: 'Kommentar', value: 'comment'}
         */
      ]
    }
    if (this.hideAktions){
      this.headers.pop()
    }
    this.$nextTick(function () {
      cmp.reload()
    })
    this.resize()
  }
}
</script>

<style scoped>

</style>
